import React, { useEffect } from 'react';
import { useTabAuth } from '../hooks/useTabAuth';

export const Logout = () => {
  const { logout } = useTabAuth();

  useEffect(() => {
    // Clear all authentication data
    logout();
    
    // Clear localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    
    // Redirect to login
    window.location.href = '/login';
  }, [logout]);

  return null;
};
